import Vue from 'vue'
import Router from 'vue-router'
const home = resolve => require.ensure([], () => resolve(require('../view/home.vue')), 'home');
const index = resolve => require.ensure([], () => resolve(require('../view/index.vue')), 'index')
const selected = resolve => require.ensure([], () => resolve(require('../view/selected.vue')), 'selected')
const articleList = resolve => require.ensure([], () => resolve(require('../view/ArticleList.vue')), 'articleList')
const userArticleList = resolve => require.ensure([], () => resolve(require('../view/user/articleList.vue')), 'userArticleList')
const newsFlash = resolve => require.ensure([], () => resolve(require('../view/newsFlash.vue')), 'newsFlash')
const articleDetail = resolve => require.ensure([], () => resolve(require('../view/articleDetail.vue')), 'articleDetail')
const club = resolve => require.ensure([], () => resolve(require('../view/club/index.vue')), 'club')
const yuxin = resolve => require.ensure([], () => resolve(require('../view/yuxin/index.vue')), 'yuxin')
const clubDetail = resolve => require.ensure([], () => resolve(require('../view/club/clubDetail.vue')), 'clubDetail')
const thinkTankMember = resolve => require.ensure([], () => resolve(require('../view/thinkTank/member.vue')), 'thinkTankMember')
const thinkTankIntro = resolve => require.ensure([], () => resolve(require('../view/thinkTank/intro.vue')), 'thinkTankIntro')
const tag = resolve => require.ensure([], () => resolve(require('../view/tag/index.vue')), 'tag')
const videoList = resolve => require.ensure([], () => resolve(require('../view/VideoList.vue')), 'videoList')
const videoDetail = resolve => require.ensure([], () => resolve(require('../view/videoDetail.vue')), 'videoDetail')
// const smart = resolve => require.ensure([],() => resolve(require('../view/smart/index.vue')),'smart');


const rank = resolve => require.ensure([], () => resolve(require('../view/rank/index.vue')),'rank')

const smart = resolve => require.ensure([], () => resolve(require('../view/rank/smart/index.vue')),'smart')
// const rankZnzc = resolve => require.ensure([], () => resolve(require('../view/rank/smart/znzc/index.vue')),'rankZnzc')
// const rankZnjs = resolve => require.ensure([], () => resolve(require('../view/rank/smart/znjs/index.vue')),'rankZnjs')
// const rankOtasj= resolve => require.ensure([], () => resolve(require('../view/rank/smart/otasj/index.vue')),'rankOtasj')

const sales = resolve => require.ensure([], () => resolve(require('../view/rank/sales/index.vue')),'rankSales')
const list = resolve => require.ensure([], () => resolve(require('../view/rank/sales/list/index.vue')),'rankSales')
const rankSerie = resolve => require.ensure([], () => resolve(require('../view/rank/sales/serie/index.vue')),'rankSerie')
const rankProvince = resolve => require.ensure([], () => resolve(require('../view/rank/sales/province/index.vue')),'rankProvince')
const rankBrand = resolve => require.ensure([], () => resolve(require('../view/rank/sales/brand/index.vue')),'rankBrand')
const rankEnterprise = resolve => require.ensure([], () => resolve(require('../view/rank/sales/enterprise/index.vue')),'rankEnterPrise')

const otaReport = resolve => require.ensure([], () => resolve(require('../view/rank/otaReport/index.vue')),'rankOtasj')

const rankDetail = resolve => require.ensure([], () => resolve(require('../view/rank/detail/index.vue')),'rankDetail')

const login = resolve => require.ensure([], () => resolve(require('../view/login/login.vue')),'login')


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      children: [
        {path: '', name: 'index', component: index, meta: {title: '首页__车云'}},
        {path: 'selected', component: selected, name: 'selected', meta: {title: '车云精选'}},
        {path: 'articleList/:id/:cate_name', name: 'articleList', component: articleList},
        {path: 'user/articleList/:id',name: 'userArticleList',component: userArticleList, meta: {title: '个人中心'}},
        {path: 'articleDetail/:id',name: 'articleDetail',component: articleDetail, meta: {title: '文章详情'}},
        {path: 'newsFlash', name: 'newsFlash', component: newsFlash, meta: {title: '快讯'}},
        {path: 'club', name: 'club', component: club, meta: {title: '活动与论坛'}},
        {path: 'yuxin', name: 'yuxin', component: yuxin, meta: {title: '与新思享会'}},
        {path: 'club/:id/:title', name: 'clubDetail', component: clubDetail, meta: {title: '活动与论坛详情'}},
        {path: 'thinkTank/member', name: 'thinkTankMember', component: thinkTankMember, meta: {title: '智库成员'}},
        {path: 'thinkTank/intro', name: 'thinkTankIntro', component: thinkTankIntro, meta: {title: '智库简介'}},
        {
          path:'tag/:tag_name',name: 'tag', component:tag
        },
        {
          path:'videoList',
          name:'videoList',
          component:videoList,
          meta:{
            title:'视频'
          }
        },
        {
          path:'videoDetail/:id',
          name:'videoDetail',
          component:videoDetail,
          meta:{
            title:'视频详情'
          }
        },
        {
          path:'rank',
          name:'rank',
          component:rank,
          meta:{
            title:'智能汽车科技榜'
          },
          children:[
            {
              path:'smart',
              name:'rank_smart',
              component:smart,
              // redirect:'/rank/smart/znzc',
              meta:{
                title:'智能汽车科技榜'
              }
            },
            {
              path:'sales',
              name:'ranl_sales',
              component:sales,
              redirect:'/rank/sales/list',
              meta:{
                title:'排行榜'
              },
              children:[
                {
                  path:'list',
                  name:'rank_sales_list',
                  component:list,
                  meta: {
                    title: '销量排行榜'
                  }
                },
                {
                  path:'serie',
                  name:'rank_sales_serie',
                  component:rankSerie,
                  meta: {
                    title: '销量排行榜——车系'
                  }
                },
                {
                  path: 'province',
                  name: 'rank_sales_province',
                  component: rankProvince,
                  meta: {
                    title: '销量排行榜——地区'
                  }
                },
                {
                  path: 'brand',
                  name: 'rank_sales_brand',
                  component: rankBrand,
                  meta: {
                    title: '销量排行榜——品牌'
                  }
                },
                {
                  path: 'enterprise',
                  name: 'rank_sales_enterprise',
                  component: rankEnterprise,
                  meta: {
                    title: '销量排行榜——厂商'
                  }
                }


              ]
            },
            {
              path:'otaReport',
              name:'rank_smart_otaReport',
              component:otaReport,
              meta:{
                title:'OTA报告'
              }
            }
          ]
        },
        {path: 'rankDetail', name: 'rankDetail', component: rankDetail, meta: {title: '榜单车型详情'}}
      ],
      redirect:'/' //默认子路由
    },
    {path:'/login',name:'login',component:login,meta:{title:'登录'}}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js